const api = {
	// base: 'http://localhost:8080',
	base: 'https://khangyuno.id.vn',
	provinces: 'https://provinces.open-api.vn/api/?depth=3',
	auth: '/api/auth',
	tours: '/api/tours',
	booking: '/api/bookings',
	user: '/api/users',
	tourDetail: '/api/tour-details',
	category: '/api/categories',
	report: '/api/report',
	guide: '/api/guide',
	destinations: '/api/destinations',
	hotel: '/api/hotels',
	wishlist: '/api/wishlist',
	transport: '/api/transports',
	// adminUser: '/api/admin/user',
	adminGuide: '/api/admin/guide',
	blog: '/api/admin/blog',
	adminSupport: '/api/admin/support',
	adminRating: '/api/admin/review',
	adminVoucher: '/api/admin/voucher',
	payment: '/api/payments',
	adminTourDetails: '/api/tour-details',
	translator: '/api/translator',
	rating: '/api/rating',
	imageAPI: '/api/image/',
	itinerary: '/api/itinerary',
	wallet: '/api/wallet',
};

export default api;